import React, { useState, useEffect } from "react";
import { useTemplateStore } from "../../zustand/templateStore.js";
import { useProductData } from "../../zustand/productStore.js";
import { useCartData } from "../../zustand/cartStore.js";
import { useMarketingStore } from "../../zustand/emailMarketingStore.js";
import { ChevronDownIcon, QuestionMarkIcon } from "../../utils/miscIcons.jsx";
import { useOrderCalculations } from "../../func/orderCalculations.js";
import ProductsList from "../productsList.jsx";
import DiscountInput from "../inputs/discountInput.jsx";
import Separator from "../misc/Separator.jsx";
import ExtendedWarrantyCheckbox from "./ExtendedWarrantyCheckbox.jsx";
import TotalSavings from "./TotalSavings.jsx";

const orderOverviewDrawerV3 = () => {
  const productData = useProductData();
  const { toggleOrderSummary, orderSummaryOpen, displayPopup } = useTemplateStore();
  const [warrantyEnabled, setWarrantyEnabled] = useState(null);
  const { selectedProduct, warrantyState, isDiscountApplied } = useCartData();
  const summary = window.post_template?.checkout_v4_summary;
  const shippingPolicyUrl = summary.checkout_v4_summary_shippingLink;
  const MultiplyWarranty = productData?.multiply_price_by_amount;
  const { freeShippingApplied } = useMarketingStore();

  // function returns total, subtotal, shipping prices and total savings. props: pricingPackage, isDiscountApplied, MultiplyWarranty, warrantyState, formattedString
  const orderCalculations = useOrderCalculations(
    selectedProduct,
    isDiscountApplied,
    MultiplyWarranty,
    warrantyState,
    productData.formatted_string
  );

  useEffect(() => {
    setWarrantyEnabled(productData?.add_warranty_for_product);
  }, [productData?.add_warranty_for_product]);

  const freeShippingLabel = freeShippingApplied
    ? summary.tr_checkout_v4_summary_free_shipping_applied_label
    : summary.tr_checkout_v4_summary_free_shipping_expired_label;

  return (
    <div className="orderOverviewDrawerV3">
      <div
        data-cy="cc-order-summary-container"
        className={`orderOverviewDrawerV3__topCont ${orderSummaryOpen && "orderOverviewDrawerV3__topCont__hide"}`}
      >
        <div className={`orderOverviewDrawerV3__savingsLabel__cont`}>
          <div className="orderOverviewDrawerV3__savingsLabel">{summary.tr_checkout_v4_summary_savingsLabel}</div>
          <div className="orderOverviewDrawerV3__savingsLabel">{orderCalculations?.savings}</div>
        </div>
        {freeShippingApplied && (
          <div className="orderOverviewDrawerV3__freeShippingLabelTop">
            {summary.tr_checkout_v4_summary_free_shipping_applied_label}
          </div>
        )}
        <Separator />
      </div>
      <div
        data-cy="cc-order-review-opener"
        className={`orderOverviewDrawerV3__opener ${orderSummaryOpen ? "_down" : ""} orderOverviewDrawerV3_label`}
        onClick={() => {
          toggleOrderSummary(!orderSummaryOpen);
        }}
      >
        <div className="orderOverviewDrawerV3_label_title">
          <span style={{ marginRight: "8px" }}>
            {window.post_template.checkout_v4_summary.tr_checkout_v4_order_review_accordion_title}
          </span>{" "}
          <ChevronDownIcon />
        </div>
        <div className="orderOverviewDrawerV3_label_priceContainer">
          <div className="orderOverviewDrawerV3_label_price">{orderCalculations?.total}</div>
        </div>
      </div>

      <div
        style={displayPopup ? { overflow: "visible" } : {}}
        className={`orderOverviewDrawerV3__content ${orderSummaryOpen && "orderOverviewDrawerV3__content__show"}`}
      >
        <Separator margin="16px 0px 16px 0px" />
        <ProductsList />
        {warrantyEnabled && (
          <>
            <Separator margin="16px 0px 16px 0px" />
            <ExtendedWarrantyCheckbox />
          </>
        )}
        <Separator margin="16px 0px 0px 0px" />
        {productData.enable_discount_codes && (
          <>
            <DiscountInput /> <Separator margin="0px 0px 0px 0px" />
          </>
        )}
        <div className="orderTotals__container" style={{ marginBottom: "0px" }}>
          <div className="orderTotals">
            <div className="orderTotals__item">
              <p>{window.post_template?.checkout_v4_summary.tr_checkout_v4_summary_orderLabel}</p>
              <p data-cy="summary-subtotal">{orderCalculations?.subtotal}</p>
            </div>
            <div className="orderTotals__item">
              <p data-testid="summary-shipping-label" className="orderTotals__item__shippingLabel">
                <span style={{ marginRight: "4px" }}>
                  {window.post_template.checkout_v4_summary.tr_checkout_v4_summary_shippingLabel}
                </span>{" "}
                <a className="orderTotals__item__shippingLabel--link" href={shippingPolicyUrl}>
                  <QuestionMarkIcon />
                </a>
              </p>
              <p data-cy="summary-shipping">{orderCalculations?.shipping}</p>
            </div>
            {freeShippingApplied && (
              <div
                className={`orderOverviewDrawerV3__freeShippingLabelBottom ${!freeShippingApplied ? "expired" : ""}`}
              >
                {freeShippingLabel}
              </div>
            )}
          </div>
          <Separator />
          <TotalSavings
            type={window.post_tempalte?.totalSavingsStyle}
            label={window.post_template?.checkout_v4_summary?.tr_checkout_v4_summary_savingsLabel}
            savings={orderCalculations?.savings}
          />
          <div className="total">
            <div>{window.post_template?.checkout_v4_summary.tr_checkout_v4_summary_totalLabel}</div>
            <div data-cy="summary-total">{orderCalculations?.total}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default orderOverviewDrawerV3;
